import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const ErrorGeneral = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path d="M7.333 4.667h1.333V9.33H7.333V4.667Zm1.333 6.666V9.997H7.333v1.336h1.333Z" fill="currentColor" />
    <path
      clipRule="evenodd"
      d="m4.943 1.724-3.22 3.219c-.25.25-.39.589-.39.943v4.228c0 .354.14.693.39.943l3.22 3.22c.25.25.589.39.943.39h4.228c.354 0 .693-.14.943-.39l3.22-3.22c.25-.25.39-.59.39-.943V5.886c0-.354-.14-.693-.39-.943l-3.22-3.22c-.25-.25-.59-.39-.943-.39H5.886c-.354 0-.693.14-.943.39ZM2.667 5.886l3.219-3.22h4.228l3.22 3.22v4.228l-3.22 3.22H5.886l-3.22-3.22V5.886Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default ErrorGeneral;
